const prefix = "LEVY_COLLECTION_RISK_FACTORS_";

export const CREATE_FAILED = prefix + "CREATE_FAILED";
export const CREATE_INITIALISE = prefix + "CREATE_INITIALISE";
export const CREATE_SET_DATA = prefix + "CREATE_SET_DATA";
export const CREATE_STARTED = prefix + "CREATE_STARTED";
export const CREATE_SUCCEEDED = prefix + "CREATE_SUCCEEDED";
export const DELETE_FAILED = prefix + "DELETE_FAILED";
export const DELETE_STARTED = prefix + "DELETE_STARTED";
export const DELETE_SUCCEEDED = prefix + "DELETE_SUCCEEDED";
export const EDIT_GET_FAILED = prefix + "EDIT_GET_FAILED";
export const EDIT_GET_STARTED = prefix + "EDIT_GET_STARTED";
export const EDIT_GET_SUCCEEDED = prefix + "EDIT_GET_SUCCEEDED";
export const EDIT_SAVE_FAILED = prefix + "EDIT_SAVE_FAILED";
export const EDIT_SAVE_STARTED = prefix + "EDIT_SAVE_STARTED";
export const EDIT_SAVE_SUCCEEDED = prefix + "EDIT_SAVE_SUCCEEDED";
export const EDIT_SET_DATA = prefix + "EDIT_SET_DATA";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
